import React from 'react';

import { Grid, Section } from '@gogame/components';
import { withForm, FormField, SidePageV2 } from '@gogame/form';

import ColorPickerFormField from 'scenes/Labels/components/ColorPickerFormField';

import { NAME, COLOR } from './constants';
import { labelsValidationSchema } from './schemas';

export default withForm({
  validationSchema: labelsValidationSchema,
  enableReinitialize: true,
})(({ title, subTitle, loading, onClose, onExited, open, entityId }) => {
  return (
    <SidePageV2
      onClose={onClose}
      onExited={onExited}
      loading={loading}
      open={open}
      size={'lg'}
    >
      <SidePageV2.Title title={title} subTitle={subTitle} entityId={entityId} />
      <SidePageV2.NewBody wrapper={true} dense={true}>
        <Section title={'General'} style={{ width: '100%' }}>
          <Grid container spacing={4}>
            <Grid item xs={8}>
              <FormField.TextField
                name={NAME}
                label={'Name'}
                padding={0}
                required
              />
            </Grid>
            <Grid item xs={4}>
              <ColorPickerFormField name={COLOR} basis={'150px'} padding={0} />
            </Grid>
          </Grid>
        </Section>
      </SidePageV2.NewBody>
      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton />
      </SidePageV2.Actions>
    </SidePageV2>
  );
});
